import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/store/samsung-wallpaper.jpg'
import _imports_1 from '../../../assets/logo.png'


const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "fixed border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[600px] w-[300px] bottom-[-180px] left-1/2 transform -translate-x-1/2" }
const _hoisted_4 = { class: "rounded-[2rem] overflow-hidden w-[272px] h-[572px] bg-white" }
const _hoisted_5 = { class: "shadow-sm w-12 h-12 my-3 flex flex-col items-center absolute top-4 left-5 z-10" }
const _hoisted_6 = {
  key: 0,
  class: "text-xs font-medium text-white mt-[2px] tracking-wide"
}
const _hoisted_7 = {
  key: 1,
  class: "text-xs font-medium text-white mt-[2px] tracking-wide"
}
const _hoisted_8 = {
  key: 0,
  class: "absolute top-6 left-4 z-20",
  width: "56",
  height: "56"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "font-medium text-2xl" }, " Подождите, приложение устанавливается ", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-xl" }, "Обычно на установку требуется не более 10 секунд", -1))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "font-medium text-2xl" }, "Приложение успешно установлено", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-xl" }, "Перейдите в список приложений и найдите его", -1))
          ], 64))
    ])), [
      [_directive_auto_animate]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"h-[32px] w-[3px] bg-gray-800 absolute -left-[17px] top-[72px] rounded-l-lg\"></div><div class=\"h-[46px] w-[3px] bg-gray-800 absolute -left-[17px] top-[124px] rounded-l-lg\"></div><div class=\"h-[46px] w-[3px] bg-gray-800 absolute -left-[17px] top-[178px] rounded-l-lg\"></div><div class=\"h-[64px] w-[3px] bg-gray-800 absolute -right-[17px] top-[142px] rounded-r-lg\"></div><div id=\"confetti\" class=\"z-20 fixed top-0\"></div>", 5)),
      _createElementVNode("div", _hoisted_4, [
        _cache[5] || (_cache[5] = _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          class: "w-[272px] h-[572px] object-cover"
        }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _imports_1,
            class: "rounded",
            alt: "logo",
            style: _normalizeStyle({ filter: _ctx.isLoading ? 'none' : 'blur(1px)' })
          }, null, 4),
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Установка "))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.appName), 1))
        ]),
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("circle", {
                cx: "28",
                cy: "28",
                r: "26",
                stroke: "white",
                "stroke-width": "4",
                fill: "transparent"
              }, null, -1),
              _createElementVNode("circle", {
                class: "progress",
                cx: "28",
                cy: "28",
                r: "26",
                stroke: "grey",
                "stroke-width": "4",
                "stroke-dasharray": "163.362",
                "stroke-dashoffset": "163.362",
                fill: "transparent"
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}